import HarleyFreespinRecord from "integration/records/freespin-record";
import FreespinsWheelRecord from "integration/records/freespins-wheel-record";
import WheelBonusRecord from "integration/records/wheel-bonus-record";
import Components from "slotworks/components/components";
import RecoveryRecordBuilderBase from "slotworks/integration/revolver/builders/records/recovery-record-builder-base";
import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import { BetState, User } from "slotworks/integration/revolver/schema/init-record-schema";
import betModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import settingsModel from "slotworks/model/settings/settings-model";
import slotDefinition from "slotworks/model/slot-definition";

class HarleyRecoveryRecordBuilderBase extends RecoveryRecordBuilderBase {
    
    public build(gameplay: Gameplay, data: any): Record[] {
        const openResponse: OpenRecordSchema = data.data as OpenRecordSchema;

        const isLateFreespins = GameState.getCurrentGame().isRecovered && RevolverModel.isFreespin(openResponse.OPEN.game);
        const isFreespinsWheel = openResponse.OPEN.game === "FREESPIN_WHEEL_BONUS";
        const isBonusWheel = openResponse.OPEN.game === "WHEEL_BONUS";

        if (isLateFreespins) {
            const firstRecord = GameState.getCurrentGame().getFirstRecord();
            if (!(firstRecord instanceof FreespinRecord) && !firstRecord.beenPaid) {
                const preservedDummyWin = GameState.getCurrentGame().getFirstRecord().creditsWon;

                const dummySpinRecord = new FreespinRecord();
                GameState.getCurrentGame().records[0] = dummySpinRecord;
                this.populateDummyRecord(dummySpinRecord);
                dummySpinRecord.totalFreespins = openResponse.OPEN.state.total;
                dummySpinRecord.remainingFreespins = openResponse.OPEN.state.remain;
                const recoveredFSWin = parseFloat(openResponse.OPEN.state.total_win_cash as any);
                dummySpinRecord.creditsWon = recoveredFSWin + preservedDummyWin;

                gameplay.totalCreditsWon += parseFloat(recoveredFSWin as any);
                gameplay.totalFreespinsCreditsWon += recoveredFSWin;
            }

            return [];
        }

        if (openResponse.USER) {
            gameplay.balance = openResponse.USER.balance;
        }

        RevolverModel.game = openResponse.OPEN.game;
        RevolverModel.bet = JSON.stringify(openResponse.OPEN.bet_state);

        const recoveryRecords: Record[] = [];

        if(isFreespinsWheel) {
            gameplay.isRecovered = true;
            const freespinWheelRecord = new FreespinsWheelRecord();
            freespinWheelRecord.spins = openResponse.OPEN.state.spins;
            freespinWheelRecord.remain = openResponse.OPEN.state.remain;
            freespinWheelRecord.is_complete = openResponse.OPEN.state.is_complete;
            freespinWheelRecord.total = openResponse.OPEN.state.total;
            freespinWheelRecord.spinsWon = openResponse.OPEN.state.spins_won;
            recoveryRecords.push(freespinWheelRecord);
        } else if(isBonusWheel) {
            if(openResponse.OPEN.state.triggering_game && RevolverModel.isFreespin(openResponse.OPEN.state.triggering_game)) {
                const dummySpinRecord = new HarleyFreespinRecord();
                this.populateDummyRecord(dummySpinRecord);

                recoveryRecords.push(dummySpinRecord);
            }
            
            gameplay.isRecovered = true;
            const wheelBonusRecord = new WheelBonusRecord();
            wheelBonusRecord.is_complete = openResponse.OPEN.state.is_complete;
            // wheelBonusRecord.giftedAdditional = openResponse.OPEN.state.giftedAdditional;
            wheelBonusRecord.creditsWon = openResponse.OPEN.state.total_win_cash;
            wheelBonusRecord.total = openResponse.OPEN.state.total;
            wheelBonusRecord.remain = openResponse.OPEN.state.remain;
            recoveryRecords.push(wheelBonusRecord);
        } else if (openResponse.OPEN.game.indexOf("BASE") === -1) {
            gameplay.isRecovered = true;

            const isFreeSpin = RevolverModel.isFreespin(openResponse.OPEN.game);
            const dummySpinRecord = isFreeSpin ? new HarleyFreespinRecord() : new SpinRecord();
            this.populateDummyRecord(dummySpinRecord);

            recoveryRecords.push(dummySpinRecord);

            /*
            state
                game: "FREE_SPINS_12"
                giftedAdditional: 2
            */
                
            const betState = openResponse.OPEN.bet_state;
            const coinLevel = slotDefinition.coinSizes[betState.coin_level - 1];
            betModel.setDefaults(slotDefinition.stakes[betState.bet_level - 1], betState.lines, coinLevel);
            Components.paytable.refreshBetOptions();
            settingsModel.betState = betState;
            this.recoverBonuses(gameplay, data, openResponse, dummySpinRecord, recoveryRecords);

            if(dummySpinRecord instanceof HarleyFreespinRecord) {
                dummySpinRecord.giftedAdditional = (openResponse.OPEN.state as any).giftedAdditional;
            }
        }
        return recoveryRecords;
    }
}

const HarleyRecoveryRecordBuilder = new HarleyRecoveryRecordBuilderBase();
export default HarleyRecoveryRecordBuilder;


interface OpenRecordSchema {
    OPEN: Open;
    USER: User;
    time: number;
}
export interface Open {
    game: string;
    bet_state: BetState;
    state: State;
}

export interface State {
    buyoutGame: boolean;
    game: string;
    total: number;
    spins: number;
    total_win_cash: number;
    remain: number;
    spins_won: number;
    stickedWildsList: number[];
    is_complete: boolean;
    total_bonus_games_win_amount: number;
    total_base_game_win_amount: number;
    trigger_stack: string;
    triggering_game: string;
}
